import { useAppHelpers } from "@/composables/useAppHelpers";
import { useAuthStore } from '@/stores/auth-store';
import axios from "axios";
import router from "@/router";
import { getCsrfToken } from "@/utils/csrf.js";

const apiClient = axios.create({
	baseURL: "/api/",
	headers: {
		"X-Requested-With": "XMLHttpRequest",
		"Content-Type": "application/json",
		"Accept": "application/json"
	},
	withCredentials: true,
	xsrfCookieName: "XSRF-TOKEN",
	xsrfHeaderName: "X-XSRF-TOKEN"
});

// const getDecodedXsrfCookie = () => {
// 	try {
// 		const raw = useAppHelpers().getCookie("XSRF-TOKEN");
// 		return raw ? decodeURIComponent(raw) : null;
// 	}
// 	catch(e) {
// 		return null;
// 	}
// }

apiClient.interceptors.request.use(function(config) {
	// const token = getDecodedXsrfCookie();
	// if(token) {
	// 	config.headers["X-XSRF-TOKEN"] = token;
	// }
	// let accessToken = localStorage.getItem("accessToken");
	// if(accessToken){
	//     config.headers["Authorization"] = "Bearer " + accessToken;
	// }
	return config;
});

let isRefreshingCsrf = false;
let isLoggingOut = false;

apiClient.interceptors.response.use(
	(response) => {
		return response;
	},
	async(error) => {
		const {response, config} = error;
		if(!response) {
			return Promise.reject(error);
		}
		const status = response.status;
		if(status === 419) {
			if(!isRefreshingCsrf) {
				isRefreshingCsrf = true;
				try {
					const helpers = useAppHelpers();
					if(helpers?.deleteAllCookies) {
						helpers.deleteAllCookies("XSRF-TOKEN");
					}
					
					await webClient.get("/sanctum/csrf-cookie");
					await getCsrfToken?.();
				}
				finally {
					isRefreshingCsrf = false;
				}
			}
			if(!config._retry) {
				try {
					config._retry = true;
					await webClient.get("/sanctum/csrf-cookie");
					return apiClient(config);
				}
				catch(e) {
					window.location.reload();
				}
			}
		}
		if(status === 404) {
			const urlHandledInternally = ['error', 'basic-page', 'specific-page'];
			if(!urlHandledInternally.includes(router.currentRoute.value.name)) {
				await router.push({name: "error"});
			}
		}
		if(status === 401) {
			const auth = useAuthStore();
			if(!isLoggingOut && auth.isLoggedIn) {
				try {
					isLoggingOut = true;
					await auth.processLogout();
					if(router.currentRoute.value.name !== "login") {
						await router.push({name: "login"});
					}
				}
				finally {
					isLoggingOut = false;
				}
			}
		}
		return Promise.reject(error);
	}
);

export const webClient = axios.create({
	withCredentials: true
});

export default apiClient;
